<template>
  <div v-bind="attrs">
    <svg
      :width="width || 18"
      :height="height || 18"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        ref="path"
        d="M15.8583 15.2333C16.7125 15.8292 17.3333 16.8458 17.3333 18C17.3333 19.8417 15.8417 21.3333 14 21.3333C12.1583 21.3333 10.6667 19.8417 10.6667 18C10.6667 17.65 10.7208 17.3083 10.8208 16.9917L4.75417 11.6833C4.325 11.8875 3.84208 12 3.33333 12C1.4925 12 0 10.5083 0 8.66667C0 6.825 1.4925 5.33333 3.33333 5.33333C4.24583 5.33333 5.07083 5.7 5.675 6.29583L13.3333 3.23C13.3875 1.43667 14.8583 0 16.6667 0C18.5083 0 20 1.4925 20 3.33333C20 4.9125 18.9042 6.23333 17.4333 6.57917L15.8583 15.2333ZM6.5125 9.675L12.5792 14.9833C12.7875 14.8875 13.0042 14.8083 13.2333 14.7542L14.8083 6.1C14.6333 5.98333 14.475 5.85 14.325 5.70417L6.62917 8.77083C6.65417 9.08333 6.60417 9.3875 6.5125 9.675Z"
        fill="#1C2025"
      />
    </svg>
  </div>
</template>
<script>
export default {
  props: ["width", "height"],
  computed: {
    attrs() {
      return {
        ...this.$attrs,
        class: this.$attrs.className,
      };
    },
  },
  mounted() {
    if (!this.$refs.path) return;

    if (this.$attrs.color) {
      this.$refs.path.setAttribute("fill", this.$attrs.color);
    }
  },
};
</script>
